"use client";

import { LoadingPage } from "@/components";

export default function Loading() {
  return <LoadingPage />;
}
